import { render, staticRenderFns } from "./RecordPaymentDialog.vue?vue&type=template&id=23f61dc1&scoped=true&"
import script from "./RecordPaymentDialog.vue?vue&type=script&lang=js&"
export * from "./RecordPaymentDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecordPaymentDialog.vue?vue&type=style&index=0&id=23f61dc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f61dc1",
  null
  
)

export default component.exports